import { List } from 'immutable';
import PropTypes from 'prop-types';
import FormState from '../../constants/FormState';
import TransactionTypes from '../../constants/TransactionTypes';
import ImmutablePropTypes from 'react-immutable-proptypes';

export const MessageShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired,
  description: PropTypes.string
});

export const LinkShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  favorite: PropTypes.bool
});

export const DateRangeShape = PropTypes.shape({
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired
});

export const D3MarginsShape = PropTypes.shape({
  top: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number
});

export const D3SymbolFunc = PropTypes.shape({
  draw: PropTypes.func.isRequired
});

export const D3SymbolShape = PropTypes.oneOfType([
  PropTypes.oneOf([
    'circle',
    'cross',
    'diamond',
    'square',
    'star',
    'triangle',
    'wye'
  ]),
  D3SymbolFunc
]);

export const LeaderShape = PropTypes.shape({
  name: PropTypes.string,  //.isRequired,
  key: PropTypes.string,  //.isRequired,
  showKey: PropTypes.bool,  //.isRequired,
  guidesCompleted: PropTypes.number,  //.isRequired,
  leadsTransmitted: PropTypes.number, //.isRequired,
  total: PropTypes.number,  //.isRequired,
  converted: PropTypes.number,  //.isRequired,
  recommendedProducts: PropTypes.number,  //.isRequired,
  accountsOpened: PropTypes.number, //.isRequired,
  guideCompletionPercentage: PropTypes.number, //.isRequired,
  leadTransmissionPercentage: PropTypes.number, //.isRequired,
  conversionPercentage: PropTypes.number, //.isRequired,
  recommendationsPerClient: PropTypes.number, //.isRequired,
  accountsOpenedPerClient: PropTypes.number,  //.isRequired,
  accountsOpenedPercentage: PropTypes.number, //.isRequired,
  conversationScore: PropTypes.number,  //.isRequired,
  accountScore: PropTypes.number  //.isRequired
});

export const ImmutableLeaderShape = ImmutablePropTypes.contains({
  name: PropTypes.string,  //.isRequired,,
  key: PropTypes.string,  //.isRequired,,
  showKey: PropTypes.bool,  //.isRequired,,
  guidesCompleted: PropTypes.number,  //.isRequired,
  leadsTransmitted: PropTypes.number, //.isRequired,
  total: PropTypes.number,  //.isRequired,,
  converted: PropTypes.number,  //.isRequired,
  recommendedProducts: PropTypes.number,  //.isRequired,
  accountsOpened: PropTypes.number, //.isRequired,
  guideCompletionPercentage: PropTypes.number, //.isRequired,
  leadTransmissionPercentage: PropTypes.number, //.isRequired,
  conversionPercentage: PropTypes.number, //.isRequired,
  recommendationsPerClient: PropTypes.number, //.isRequired,
  accountsOpenedPerClient: PropTypes.number,  //.isRequired,
  accountsOpenedPercentage: PropTypes.number, //.isRequired,
  conversationScore: PropTypes.number,  //.isRequired,
  accountScore: PropTypes.number  //.isRequired
});

export const ComplianceLeaderShape = PropTypes.shape({
  name: PropTypes.string,
  key: PropTypes.string,
  flaggedConversations: PropTypes.number.isRequired,
  noncompliancePercentage: PropTypes.number.isRequired
});

export const ActionShape = PropTypes.shape({
  actions: PropTypes.object.isRequired
});

export function KeyValueShape(keyType = PropTypes.string.isRequired, valueType) {
  return PropTypes.shape({
    key: keyType,
    value: valueType || keyType
  });
}

export function KeyValueActiveShape(keyType = PropTypes.string.isRequired, valueType) {
  return PropTypes.shape({
    key: keyType,
    value: valueType || keyType,
    active: PropTypes.boolean
  });
}

export function KeyValueEnabledActiveShape(keyType = PropTypes.string.isRequired, valueType) {
  return PropTypes.shape({
    key: keyType,
    value: valueType || keyType,
    active: PropTypes.boolean,
    enabled: PropTypes.boolean
  });
}

export const SeriesShape = PropTypes.shape({
  name: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.object).isRequired,
  extractX: PropTypes.func,
  extractY: PropTypes.func,
  extractKey: PropTypes.func,
  shape: D3SymbolShape
});

export const ManagedUserShape = PropTypes.shape({
  emailAddress: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  roles: PropTypes.arrayOf(KeyValueEnabledActiveShape).isRequired,
  selectedBranchHierarchy: PropTypes.instanceOf(List)
});

export const ClientGeographyShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const ProductActionShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired
});

export const ProductCategoryShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  description: PropTypes.string
});

export const ProductLocationShape = PropTypes.shape({
  branches: PropTypes.arrayOf(PropTypes.string)
});

export const ProductShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.shape({
    internal: PropTypes.string,
    short: PropTypes.string.isRequired,
    long: PropTypes.string
  }).isRequired,
  category: PropTypes.string.isRequired,
  priority: PropTypes.number.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  url: PropTypes.string.isRequired,
  applicationUrl: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  rules: PropTypes.array,
  cost: PropTypes.object,
  disclosures: PropTypes.arrayOf(PropTypes.string),
  locations: ProductLocationShape
});

export const FormStateShape = PropTypes.oneOf(Object.keys(FormState));

export const MessageDefinitionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired
});

export const ThemeAttributesShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  options: PropTypes.shape({
    colors: PropTypes.object
  })
});

export const GuideShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  domain: PropTypes.string,
  type: PropTypes.oneOf(['business','consumer']),
  delivery: PropTypes.oneOf(['branch','online']),
  products: PropTypes.array,
  theme: ThemeAttributesShape,
  tone: PropTypes.shape({
    key: PropTypes.string.isRequired
  }),
  attributes: PropTypes.object
});

export const ThemeShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  components: PropTypes.shape({
    landing: PropTypes.func.isRequired,
    question: PropTypes.func.isRequired,
    product: PropTypes.func.isRequired
  }).isRequired,
  defaults: PropTypes.shape({
    colors: PropTypes.object.isRequired
  }).isRequired,
  thumbnailUrl: PropTypes.string.isRequired,
});

export const ContactShape = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string
});


export const AddressShape = PropTypes.shape({
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string
});

export const BankInfoShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  contact: ContactShape.isRequired,
  address: AddressShape.isRequired
});

export const BankBranchShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  address: AddressShape.isRequired,
  active: PropTypes.bool.isRequired
});

export const EnvironmentShape = PropTypes.shape({
  environmentKey: PropTypes.string.isRequired,
  pendingPublish: PropTypes.bool.isRequired,
  productsChanged: PropTypes.arrayOf(PropTypes.string).isRequired,
  guidesChanged: PropTypes.arrayOf(PropTypes.string).isRequired,
  branchesChanged: PropTypes.arrayOf(PropTypes.string).isRequired
});

export const PublicationShape = PropTypes.shape({
  clientKey: PropTypes.string.isRequired,
  environments: PropTypes.arrayOf(EnvironmentShape)
});

export const HistogramShape = PropTypes.shape({
  year: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  timestamp: PropTypes.instanceOf(Date)
});

export const LinkDescriptionShape = PropTypes.shape({
  to: PropTypes.string.isRequired,
  requiredRole: PropTypes.string,
  message: MessageShape.isRequired
});

export const GuidePriceTierShape = PropTypes.shape({
  levels: PropTypes.arrayOf(PropTypes.number).isRequired,
  fullDiscount: PropTypes.number
});

export const GuidePricingShape = PropTypes.shape({
  oneYear: GuidePriceTierShape.isRequired,
  twoYear: GuidePriceTierShape.isRequired,
  threeYear: GuidePriceTierShape.isRequired
});

export const SupportLevelShape = PropTypes.shape({
  price: PropTypes.number.isRequired,
  hours: PropTypes.number.isRequired
});

export const SupportLevelsShape = PropTypes.shape({
  basic: SupportLevelShape.isRequired,
  standard: SupportLevelShape.isRequired,
  advanced: SupportLevelShape.isRequired
});

export const SupportLevelsEnum = PropTypes.oneOf(['basic', 'standard', 'advanced']);

export const PaymentShape = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  method: PropTypes.oneOf(['ach', 'check']).isRequired,
  guideCount: PropTypes.number.isRequired,
  supportLevel: SupportLevelsEnum.isRequired
});

export const SubscriptionRequestShape = PropTypes.shape({
  selections: PropTypes.shape({
    guides: PropTypes.shape({
      count: PropTypes.number,
      term: PropTypes.string
    }),
    support: PropTypes.shape({
      level: SupportLevelsEnum.isRequired
    })
  }).isRequired,
  agentName: PropTypes.string.isRequired,
  authorization: PropTypes.bool.isRequired
});

export const TransactionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([TransactionTypes.payment, TransactionTypes.subscriptionRequest]),
  timestamp: PropTypes.instanceOf(Date).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
    emailAddress: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    serviceName: PropTypes.string
  }),
  attributes: PropTypes.oneOfType([PaymentShape, SubscriptionRequestShape])
});

export const SampleShape = PropTypes.shape({
  text: PropTypes.string.isRequired,
  answers: PropTypes.arrayOf(PropTypes.string)
});

export const ToneShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  samples: PropTypes.shape({
    checkingBalance: SampleShape.isRequired,
    productPreference: SampleShape.isRequired,
    customerType: SampleShape.isRequired
  })
});

export const ConversationShape = PropTypes.shape({
  employeeId: PropTypes.string.isRequired,
  answers: PropTypes.array,
  timestamp: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  uuid: PropTypes.string.isRequired,
  products: PropTypes.array,
  productsMatchedCount: PropTypes.number,
  productsOpenedCount: PropTypes.number,
  url: PropTypes.string
});

export const ComplianceConversationDetailsViewShape = PropTypes.shape({
  uuid: PropTypes.string,
  timestamp: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  url: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    category: PropTypes.string,
    matched: PropTypes.bool,
    opened: PropTypes.bool
  }))
});



// WEBPACK FOOTER //
// ./src/utils/react/Shapes.js